<template>
  <Card
    background="copy"
    color="background"
    direction="column"
    title="Internal Notes"
    stack-style="display: block"
  >
    <TextComponent>
      Is there anything special about this user that we should make note of?
    </TextComponent>
    <Textarea v-model="text" name="Text" style="flex-grow: 1; width: 100%"/>
    <Button :disabled="saved" :loading="loading" @click="submit">
      {{ saved ? 'Submitted' : 'Submit'}}
    </Button>
  </Card>
</template>

<script>
  import Button from '@hackthe6ix/vue-ui/Button';
  import Stack from '@hackthe6ix/vue-ui/Stack';
  import TextComponent from '@hackthe6ix/vue-ui/Text';
  import Textarea from '@hackthe6ix/vue-ui/Textarea';
  import Card from '../../../../containers/Card';

  export default {
  name: 'Notes',
  components: {
    Textarea,
    TextComponent,
    Stack,
    Card,
    Button
  },
  props: {
    currentState: String,
    updateNotes: Function
  },
  data() {
    return {
      text: "",
      loading: false,
      saved: false
    }
  },
  watch: {
    text() {
      this.saved = false;
    }
  },
  methods: {
    async submit() {
      this.loading = true;

      await this.updateNotes(this.text);

      this.loading = false;
      this.saved = true;
    }
  },
  beforeMount() {
    this.text = this.currentState || '';
  }
};
</script>
